// extracted by mini-css-extract-plugin
module.exports = {"container":"TypeSection_container__3w99X","dropdown":"TypeSection_dropdown__J4R54","subtypeDropdown":"TypeSection_subtypeDropdown__2HTZ6"};